import { PurchasedGoodsFoodListReviewType } from '@shared/api/types';
import { Icons } from '@shared/components/content/icons';
import Text from '@shared/components/content/text';
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from '@shared/components/ui/hover-card';
import { cn } from '@shared/lib/utils';
import { Link } from 'react-router-dom';
import { purchasedGoodsRoutes } from '../../purchased-goods-routes';

interface NeedsReviewPopoverProps {
  itemName: string;
  reviewType: PurchasedGoodsFoodListReviewType;
  align?: 'left' | 'right';
  children: React.ReactNode;
}

export function NeedsReviewPopover({
  itemName,
  reviewType,
  align = 'left',
  children,
}: NeedsReviewPopoverProps) {
  const message =
    reviewType === PurchasedGoodsFoodListReviewType.weight
      ? 'The pack weight for this item may need review to ensure accurate total emissions'
      : 'This match may need review to ensure a high standard of emissions modelling';
  const to = `${purchasedGoodsRoutes.PURCHASED_FOOD_AND_DRINK_REVIEW}?food=${encodeURIComponent(itemName)}`;
  return (
    <HoverCard openDelay={150} closeDelay={150}>
      <HoverCardTrigger asChild>
        <span
          className={cn(
            'flex items-center gap-2',
            align === 'right' && 'justify-end'
          )}
        >
          <Icons.warning className="size-4 shrink-0 text-warning-600" />
          {children}
        </span>
      </HoverCardTrigger>
      <HoverCardContent className="w-80 space-y-2">
        <Text variant="subtle">{message}</Text>
        <Link
          to={to}
          onClick={(e) => e.stopPropagation()}
          className="flex items-center gap-1 text-sm font-medium text-teal-600 hover:cursor-pointer"
        >
          Review item
          <Icons.chevronRight className="size-4" />
        </Link>
      </HoverCardContent>
    </HoverCard>
  );
}
